import React, { useEffect, useState } from 'react';
import AdminBannerProduct from '../components/AdminBannerProduct';
import { useNavigate } from 'react-router-dom';
import ROLE from '../common/role';
import { useSelector } from 'react-redux';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import AdminNotificationBar from '../components/AdminNotificationBar';
import AdminMinimumBar from '../components/AdminMinimumBar';

const Advertisements = () => {
    const user = useSelector(state => state?.user?.user);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
   
    

    useEffect(() => {
        setLoading(true);
        if (user) {
            if(user?.role===ROLE.GENERAL){
                navigate("/");
            }
            else if (user?.role === ROLE.ADMIN && user.type !=='Admin') {
                if (user?.type === "Medicine") {
                    navigate("/admin-home");
                } else {
                    navigate("/admin-cosmetic-home");
                }
                setLoading(false);
            } 
          else if (user?.role === ROLE.SALESMAN) {
        
              navigate("/SalesManPanelPersonalInfo/salesManProfile");
              setLoading(false);
    
          }
            
            else {
                setLoading(false);
            }
        } else {
            setLoading(false);
        }
    }, [user, navigate]);

    useEffect(() => {
    }, [user]);

    if (loading) {
        return (
            <div className="flex justify-center items-center h-screen">
                <AiOutlineLoading3Quarters className="animate-spin text-6xl text-blue-500" />
            </div>
        );
    }

    return (
        <div className="home-page">
            <div style={{ marginBottom: '20px' }}>
                <AdminNotificationBar />
            </div>
            <div>
                <AdminBannerProduct />
            </div>

            <div style={{ marginTop: '20px' }}>
                <AdminMinimumBar />
            </div>
        </div>
    );

}

export default Advertisements;
